import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUnlockSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={60} height={60} fill="none" {...props}>
      <path
        stroke="url(#unlock_small_svg__a)"
        strokeWidth={5}
        d="M21.143 24.667v-8C21.143 10.776 26.003 6 32 6s10.857 4.776 10.857 10.667v2.583M18.43 54h27.14c3 0 5.43-2.388 5.43-5.333V30c0-2.945-2.43-5.333-5.429-5.333H18.43c-3 0-5.43 2.387-5.43 5.333v18.667C13 51.612 15.43 54 18.429 54Z"
      />
      <path
        fill="#0D2B57"
        d="M8.988 1.488a.487.487 0 1 0-.976 0c0 2.028-.447 3.377-1.297 4.227s-2.2 1.298-4.227 1.298a.487.487 0 1 0 0 .974c2.028 0 3.377.448 4.227 1.298s1.297 2.2 1.297 4.227a.488.488 0 0 0 .976 0c0-2.028.447-3.377 1.297-4.227s2.2-1.298 4.227-1.298a.488.488 0 0 0 0-.974c-2.028 0-3.377-.448-4.227-1.298s-1.297-2.2-1.297-4.227"
      />
      <path stroke="#0C1C43" strokeLinecap="round" d="M32 34.5v7" />
      <defs>
        <linearGradient
          id="unlock_small_svg__a"
          x1={32}
          x2={32}
          y1={6}
          y2={54}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUnlockSmall);
export default ForwardRef;
